/**
 * @generated SignedSource<<f40a6b511d5ebf2f63f7f4fbb9d90716>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type mobileNewsletterPreviewNewsletter$data = {
  readonly entityId: string;
  readonly name: string;
  readonly sourceUrl: string | null | undefined;
  readonly summary: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"signUpButtonNewsletter">;
  readonly " $fragmentType": "mobileNewsletterPreviewNewsletter";
};
export type mobileNewsletterPreviewNewsletter$key = {
  readonly " $data"?: mobileNewsletterPreviewNewsletter$data;
  readonly " $fragmentSpreads": FragmentRefs<"mobileNewsletterPreviewNewsletter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mobileNewsletterPreviewNewsletter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "signUpButtonNewsletter"
    }
  ],
  "type": "Newsletter",
  "abstractKey": null
};

(node as any).hash = "f4e8287c9d926fe8a8abce9018fc81ae";

export default node;
